type ApiResponse = import('modules/with-fetch').ApiResponse;

// https://stackoverflow.com/questions/46946380/fetch-api-request-timeout
const fetchWrapper = (
  url: string,
  options: object,
  timeout: number,
): Promise<ApiResponse> =>
  new Promise((resolve, reject): void => {
    fetch(url, options).then(resolve).catch(reject);

    if (timeout) {
      const e = new Error('Connection timed out');
      setTimeout(reject, timeout, e);
    }
  });

export default fetchWrapper;
